import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import ContentContainer from '../../layout/ContentContainer.jsx';
import MiniDoc from './MiniDoc.jsx';
import { ID_DOCUMENT_TYPES, miniDocVariant } from './idDocumentTypes.js';

const IDDocumentTypePicker = ({ acceptedDocuments = [], text, onSelect }) => (
	<ContentContainer>
		<Typography variant="h6" sx={{ mb: 1 }}>{text.typePickerTitle}</Typography>
		<Typography color="text.secondary" sx={{ mb: 3 }}>{text.typePickerSubtitle}</Typography>
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
			{acceptedDocuments.map((type) => {
				const meta = ID_DOCUMENT_TYPES[type];
				if (!meta) return null;
				return (
					<Card key={type} variant="outlined">
						<CardActionArea
							data-testid={`type-card-${type}`}
							onClick={() => onSelect(type)}
							sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}
						>
							<Box sx={{ color: 'text.primary', display: 'flex', flexShrink: 0 }}>
								<MiniDoc variant={miniDocVariant(type)} band={!!meta.band} size={28} />
							</Box>
							<Box sx={{ flex: 1, textAlign: 'left' }}>
								<Typography sx={{ fontWeight: 600 }}>{text[meta.labelKey]}</Typography>
							</Box>
						</CardActionArea>
					</Card>
				);
			})}
		</Box>
	</ContentContainer>
);

export default IDDocumentTypePicker;
